<template>
  <svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>education</title>
    <desc>Created with Sketch.</desc>
    <g id="neighborhood" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="neighborhood-poi-desktop" transform="translate(-1049.000000, -1206.000000)">
        <g id="map" transform="translate(0.000000, 612.000000)">
          <g id="POIs">
            <g transform="translate(771.000000, 107.000000)">
              <g id="education" transform="translate(280.000000, 489.000000)">
                <circle id="Oval-Copy-5" stroke="#FFFFFF" stroke-width="2" fill="#9F8054" cx="15" cy="15" r="16"></circle>
                <path d="M7.57141304,13.4740287 L8.64285103,13.9782201 L8.64285103,19.3843856 C9.2650614,19.6062726 9.71428902,20.1953693 9.71428902,20.8928608 C9.71428902,21.7790544 8.99334339,22.5 8.10714986,22.5 C7.22092068,22.5 6.50001069,21.7790544 6.50001069,20.8928608 C6.50001069,20.1953693 6.94920267,19.6062726 7.57141304,19.3844213 L7.57141304,19.3844213 L7.57141304,13.4740287 Z M20.8828832,14.7895317 L21.4169448,17.9935088 C21.3097617,18.0616254 19.303226,20.3571668 15.6428567,20.3571668 C11.9557541,20.3571668 9.94483408,18.0646552 9.83305293,17.9935088 L9.83305293,17.9935088 L10.3671145,14.7895317 L15.6428567,17.2553112 L20.8828832,14.7895317 Z M15.6428496,7.5 L24.7499834,11.7857163 L15.6428496,16.0714326 L6.5,11.7857163 L15.6428496,7.5 Z M16.1785508,11.2499795 L15.1071128,11.2499795 L15.1071128,12.3214175 L16.1785508,12.3214175 L16.1785508,11.2499795 Z" id="Combined-Shape" fill="#FFFFFF"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconPoiEducation',
};
</script>

<style></style>
